import { render } from "./Nav.vue?vue&type=template&id=34b49431&scoped=true&ts=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=34b49431&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b49431"]])

export default __exports__